import { ca } from '@cian/analytics';

import { EDeviceType } from '../../../types/device';
import { IBrokerAnalyticsUser } from '../../../types/newbuildingBroker';
import { toSiteType } from '../../../utils/trackings';

export const trackFallbackModalOpen = (user: IBrokerAnalyticsUser, deviceType: EDeviceType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BrokerDeal',
    action: 'Show',
    label: 'BrokerDealPopUpFail',
    page: {
      pageType: 'ListingFavorites',
      siteType: toSiteType(deviceType),
      extra: {
        is_link: false,
      },
    },
    user,
    useLastProducts: true,
  });
};
